import React from 'react'
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';

function PrivacyStatement() {
  return (
    <div>
        <SideBar></SideBar>
        <TopBaner></TopBaner>
          <div className="card" style={{ textAlign: "right", direction: "rtl" }}>
      <img src="/pycBlueIogo.png" alt="logo-pych" style={{ height: "100px" }} />
      <h5>מדיניות פרטיות</h5>
      <div>חברת פאייכלה מכבדת את פרטיות המשתמשים באתר ופועלת בהתאם להוראות הדין הישראלי. מטרת מדיניות זו להסביר כיצד אנו אוספים, שומרים ומשתמשים במידע אישי.</div>
      <h5>סוג המידע שנאסף</h5>
      <p>בעת שימוש באתר להזמנת נסיעה או יצירת קשר, יתכן ויתבקשו ממך הפרטים הבאים:</p>
      <ul>
        <li>שם מלא</li>
        <li>כתובת דוא"ל</li>
        <li>מספר טלפון</li>
      </ul>
      <h5>מטרות השימוש במידע</h5>
      <ul>
        <li>יצירת קשר עם המשתמש</li>
        <li>תיאום שירותי נסיעה</li>
      </ul>
      <h5>שמירת המידע</h5>
      <div>המידע נשמר במערכת Firebase המאובטחת של החברה.</div>
      <h5>העברת מידע לצד שלישי</h5>
      <div>החברה אינה מעבירה את המידע לצדדים שלישיים, למעט ככל שנדרש לפי דין.</div>
      <h5>עוגיות (Cookies)</h5>
      <div>האתר אינו עושה שימוש בעוגיות לצורך איסוף מידע אישי.</div>
      <h5>שימוש קטינים</h5>
      <div>האתר פתוח לשימוש לכלל הציבור, לרבות קטינים, ללא הגבלת גיל.</div>
      <h5>זכויות המשתמש</h5>
      <div>משתמש המעוניין לעדכן או למחוק את פרטיו יכול לפנות אלינו באמצעות כתובת הדוא"ל: PRH700262@gmail.com</div>
      </div>
        <Footer></Footer>
    </div>
  )
}

export default PrivacyStatement